import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("eko_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/** Resolve a stored image reference to a browser-loadable URL.
 *  Accepts full https URLs, data URLs, and relative /api/files/... paths. */
export function imgUrl(u) {
  if (!u) return "";
  if (u.startsWith("http") || u.startsWith("data:") || u.startsWith("blob:")) return u;
  return `${BACKEND_URL}${u.startsWith("/") ? u : "/" + u}`;
}

export default api;
